import { useState, useEffect } from "react";
import { Table, Space, Button, Row, Col, Select, Modal, Tooltip, notification, Tag, Pagination } from "antd";
import {
    EditOutlined,
    DeleteOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { driverService, quotationService } from "../../../services";
import { useDebounce } from "../../../hooks/useDebounce";
import LogModal from "./LogModal";
import { changeDocumentTitle } from "../../../utils/title";

const options = [
    {
        value: "10",
        label: "10",
    },
    {
        value: "25",
        label: "25",
    },
    {
        value: "50",
        label: "50",
    },
];

function RateSending() {
    const editRate = (id) => navigate(`/operations/rate-sending/form/${id}`);
    const navigate = useNavigate();
    const [isModalshow, setIsModalShow] = useState(false);
    const [logModal, setLogModal] = useState(false);
    const [logData, setLogData] = useState([])
    const [selectedDeleteRecord, setSelectedDeleteRecord] = useState(null);
    const [rates, setRates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        total: 0,
        pageSize: 10,
    });
    const [search, setSearch] = useState(null)
    const debouncedSearch = useDebounce(search, 500);

    const columns = [
        {
            title: "ID",
            key: "index",
            render: (_, __, index) =>
                (pagination.pageSize * (pagination.current - 1)) + (index + 1),
        },
        {
            title: "Customers",
            dataIndex: "customers",
            key: "customers",
            render: (customers) => {
                if (!customers || customers.length === 0) return "-";

                const names = customers.map(c => c.name).filter(Boolean);

                const chunks = [];
                for (let i = 0; i < names.length; i += 4) {
                    chunks.push(names.slice(i, i + 4));
                }

                return (
                    <div>
                        {chunks.map((group, index) => (
                            <div key={index}>{group.join(", ")}</div>
                        ))}
                    </div>
                );
            },
        },
        {
            title: "Status",
            dataIndex: "is_sended",
            key: "is_sended",
            render: (text) => <Tag color={text === 0 ? "orange" : "green"}>{text === 0 ? "Draft" : "Sent"}</Tag>
        },
        {
            title: "Date",
            dataIndex: "date",
            key: "date",
        },
        {
            title: "Valid Till",
            dataIndex: "valid_till",
            key: "valid_till",
        },
        {
            title: "Created By",
            dataIndex: ["created_by", "name"],
            key: "created_by",
            render: (text) => text ? text : "-"
        },
        {
            title: "Updated By",
            dataIndex: ["updated_by", "name"],
            key: "updated_by",
            render: (text) => text ? text : "-"
        },
        {
            title: "Created At",
            dataIndex: "created_at",
            key: "created_at",
            render: (text) => {
                if (!text) return null;
                const [date, timeWithZone] = text.split("T");
                const time = timeWithZone.replace("Z", "").split(".")[0];

                return (
                    <div className="flex flex-col">
                        <span>{date}</span>
                        <span className="text-gray-500 text-xs">{time}</span>
                    </div>
                );
            },
        },
        {
            title: "Action",
            key: "Action",
            render: (text, record) => (
                <Space size="small">
                    <Tooltip title='Edit'>
                        {/* <Button
                            type="primary"
                            size="small"
                        > */}
                        <EditOutlined onClick={() => editRate(record.id)} />
                        {/* </Button> */}
                    </Tooltip>

                    {record.is_sended != 1 && <Tooltip title='Delete'>
                        {/* <Button
                            type="primary"
                            size="small"
                            
                        > */}
                        <DeleteOutlined onClick={() => showModal(record)} />
                        {/* </Button> */}
                    </Tooltip>}

                    {record.is_sended === 1 && <Button
                        type="default"
                        size="small"
                        onClick={() => showLogModal(record)}
                    >
                        View Logs
                    </Button>}

                </Space>
            ),
        },
    ];

    const showLogModal = (record) => {
        setLogModal(true)
        setLogData(record.recipients)
    }

    const showModal = (record) => {
        setSelectedDeleteRecord(record);
        setIsModalShow(true);
    };

    const handleCancel = () => {
        setIsModalShow(false);
    };

    const initialize = async (page = 1, pageSize = pagination.pageSize) => {

        setLoading(true);
        const response = await quotationService.fetchRates(page, pageSize, debouncedSearch);
        setLoading(false);

        if (response?.success ?? false) {
            setRates(response.data.data);
            setPagination((prev) => ({
                ...prev,
                total: response.data.total,
                current: page,
                pageSize,
            }));
        }
    };


    const handleDelete = async () => {
        setDeleteLoading(true)
        if (!selectedDeleteRecord || !selectedDeleteRecord.id) {
            console.error("No Rate selected for deletion.");
            return;
        }
        const response = await quotationService.deleteRate(selectedDeleteRecord.id);
        setDeleteLoading(false)
        if (response.success) {
            notification.success({
                message: "Rate Deleted.",
                placement: "topRight"
            })
            initialize();
        } else {
            console.error("Failed to delete the rate.");
        }
        setIsModalShow(false);
    };

    useEffect(() => {
        changeDocumentTitle("Rate Sending");
        initialize(pagination.current, pagination.pageSize);
    }, [debouncedSearch]);


    const renderDeleteModal = (
        <>
            <Modal
                title={<div style={{ textAlign: "center" }}>Confirm</div>}
                open={isModalshow}
                onOk={handleDelete}
                onCancel={handleCancel}
                centered
                styles={{
                    body: {
                        padding: "20px",
                    },
                }}
                width={300}
                footer={
                    <div className="flex justify-center gap-3">
                        <Button
                            type="default"
                            onClick={handleCancel}
                        >
                            Cancel
                        </Button>
                        <Button
                            type="primary"
                            onClick={handleDelete}
                            loading={deleteLoading}
                        >
                            Confirm
                        </Button>
                    </div>
                }
            >
                <p style={{ textAlign: "center" }}>
                    Are you sure you want to delete this?
                </p>
            </Modal>
        </>
    );

    return (
        <div style={{ padding: "5px", border: "1px solid #ccc", borderRadius: "8px", backgroundColor: "#FFFFFF" }}>

            <h1 style={{ fontWeight: "bold" }} className="pl-2 pt-3">Browse Rates</h1>



            <Table
                rowKey="id"
                columns={columns}
                dataSource={rates}
                loading={loading}
                // pagination={{
                //     current: pagination.current,
                //     total: pagination.total,
                //     pageSize: pagination.pageSize,
                //     onChange: (page) => initialize(page, pagination.pageSize),
                //     showSizeChanger: false,
                // }}
                pagination={false}
                style={{ marginTop: "10px" }}
                footer={() => (
                    <div className="flex justify-between items-center text-xs ">
                        <div className=" text-gray-600">
                            Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
                            {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
                            {pagination.total} entries
                        </div>
                        <Pagination
                            current={pagination.current}
                            total={pagination.total}
                            pageSize={pagination.pageSize}
                            showSizeChanger={false}
                            onChange={(page) => initialize(page, pagination.pageSize, search)}
                            itemRender={(current, type, originalElement) => {
                                if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                                if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                                return originalElement;
                            }}
                        />
                    </div>
                )}
            />
            <LogModal
                open={logModal}
                setOpen={setLogModal}
                logs={logData || []}
            />

            {renderDeleteModal}
        </div>
    );
}

export default RateSending;
